import type { Product } from "@/generated/graphql";
import type { AutocompleteOption } from "@k3-tech/react-kit";
import { Barcode } from "lucide-react";
import type { ReactNode } from "react";

type ProductLike = Pick<Product, "barcode" | "productCode" | "productName"> & {
	isConsignment?: boolean | null;
};

type ProductAutocompleteOptionProps = {
	option: AutocompleteOption;
	selected?: boolean;
};

export function ProductAutocompleteOption({
	option,
}: ProductAutocompleteOptionProps) {
	const source = (option.raw ?? option) as Partial<ProductLike>;
	const barcode = source.barcode?.trim();
	const productCode = source.productCode?.trim();
	const productName = source.productName?.trim() || option.label;
	const isConsignment = source.isConsignment;

	return (
		<div className="flex w-full min-w-0 items-center gap-2">
			<Barcode className="h-4 w-4 shrink-0 text-blue-600" />
			{barcode ? (
				<span className="shrink-0 font-semibold text-blue-600">{barcode}</span>
			) : null}
			<span className="min-w-0 truncate text-foreground">{productName}</span>
			{isConsignment ? (
				<span className="shrink-0 rounded bg-amber-100 px-1.5 py-0.5 text-[10px] font-semibold text-amber-800 dark:bg-amber-900/40 dark:text-amber-300">
					Consignment
				</span>
			) : null}
			{productCode ? (
				<span className="ml-auto shrink-0 pl-2 text-muted-foreground">
					{productCode}
				</span>
			) : null}
		</div>
	);
}

export function renderProductOption(
	option: AutocompleteOption,
	selected: boolean,
): ReactNode {
	return <ProductAutocompleteOption option={option} selected={selected} />;
}
